module.exports = __webpack_public_path__ + "img/Logo-App-Store.e0cc403c.png";